import moment from "moment";

/** Optional arrival dates must never become 'Invalid date' or an invented current date. */
export const normalizeDeclarationDate = (value) => {
  if (value == null || (typeof value === "string" && !value.trim())) return null;
  let date;
  if (moment.isMoment(value)) date = value.clone();
  else if (value instanceof Date || (typeof value === "number" && Number.isFinite(value))) date = moment(value);
  else if (typeof value === "string") date = moment(value.trim(), moment.ISO_8601, true);
  else return null;
  return date.isValid() ? date.toISOString() : null;
};
